import React from 'react';

export default function ListingCard({
	title,
	subtitle,
	subtitleTwo,
	titleTag,
	path,
	imgSrc,
	imgWidth,
	apikey,
	imgAlt,
	children,
}) {
	return (
		<div className='tw-flex tw-flex-col tw-border-gray-200 tw-rounded tw-shadow'>
			<div
				className={`tw-w-full tw-h-60 tw-shrink-0 tw-relative tw-rounded tw-shadow-sm ${
					!imgSrc && 'tw-flex tw-items-center tw-justify-center'
				}`}>
				{imgSrc ? (
					<>
						<div
							className={`tw-absolute tw-h-full tw-w-full tw-animate-pulse tw-bg-slate-200 tw-z-[-1] tw-rounded-t`}></div>
						<img
							className={`tw-w-full tw-h-full tw-object-cover tw-object-center tw-rounded-t`}
							src={`${path.current}${imgSrc}?width=${imgWidth}&APIKEY=${apikey}`}
							alt={imgAlt}
						/>
					</>
				) : (
					<i className='tw-text-[7rem] tw-text-black/50 fas fa-image'></i>
				)}
			</div>
			<div className='tw-flex tw-flex-col tw-h-full tw-gap-2 tw-p-2 tw-pb-4'>
				<div className='tw-items-baseline'>
					<div className='tw-flex tw-items-center'>
						<p className='tw-text-lg tw-font-bold tw-grow tw-text-[#0076C2]'>{title}</p>
						{titleTag && (
							<div className='tw-text-[0.625rem] tw-leading-3 tw-font-semibold tw-px-2 tw-py-1 tw-rounded-full tw-bg-emerald-100  tw-text-emerald-700'>
								{titleTag}
							</div>
						)}
					</div>
					{subtitle && (
						<p className='tw-text-sm tw-text-gray-500 tw-italic tw-truncate'>{subtitle}</p>
					)}
					{subtitleTwo && <p className='tw-text-sm tw-text-gray-500 tw-truncate'>{subtitleTwo}</p>}
				</div>
				{children}
			</div>
		</div>
	);
}
